import DashboardMain from "./DashboardMain.vue"
import SidebarWithHeader from "@/layouts/Sidebar/SidebarWithHeader.vue"
import {
	Route
} from "@/types"

export const route: Route[] = [
	{
		path: "/dashboard",
		name: "Dashboard",
		component: DashboardMain,
		meta: { 
			layout: SidebarWithHeader,
			module: "dashboard"
		},
	},
]

